document.addEventListener('DOMContentLoaded', function() {
  function updateAllInventoryDisplays(variantId) {
    // Alle Inventory-Blocks finden (sowohl oben als auch unten)
    const mainInventoryBlocks = document.querySelectorAll('#product-info .inventory');
    const belowGalleryInventoryBlocks = document.querySelectorAll('#product-extra-information .inventory');
    const allInventoryBlocks = [...mainInventoryBlocks, ...belowGalleryInventoryBlocks];
    
    if (allInventoryBlocks.length === 0) return;
    
    // Alle Inventory-Elemente verstecken
    allInventoryBlocks.forEach(block => {
      block.style.display = 'none';
    });
    
    // Nur das Inventory für die aktuelle Variante anzeigen
    const currentInventory = document.querySelector(`.inventory[data-variant-id="${variantId}"]`);
    if (currentInventory) {
      currentInventory.style.display = 'block';
    }
  }
  
  // Prüfen ob es ein Multi-Variant Produkt ist
  const variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
  if (variantSelects.length > 0) {
    // Multi-Variant Produkt
    document.addEventListener('variant:change', function(event) {
      updateAllInventoryDisplays(event.detail.variant.id);
    });
    
    const initialVariant = document.querySelector('input[name="id"], select[name="id"]')?.value;
    if (initialVariant) updateAllInventoryDisplays(initialVariant);
  } else {
    // Single-Variant Produkt - zeige ALLE inventory Elemente an
    const allInventoryBlocks = document.querySelectorAll('.inventory');
    allInventoryBlocks.forEach(el => {
      el.style.display = 'block';
    });
  }
});